import { ReactElement, useState } from "react";
import { observer } from "mobx-react";
import { Typography, Tooltip, ClickAwayListener, IconButton, IconButtonProps } from "@material-ui/core";
import { InformationOutline } from "mdi-material-ui";

interface InformationTooltipProps {
    title: string;
    IconButtonProps?: IconButtonProps;
    icon?: ReactElement;
}

const InformationTooltip = observer((props: InformationTooltipProps) => {

    /***** State *****/

    const [open, setOpen] = useState(false);

    /***** Event handlers *****/

    const onInfoButtonClicked = () => {
        setOpen(true);
    }

    const onTooltipOpen = () => {
        setOpen(true);
    }

    const onTooltipClose = () => {
        setOpen(false);
    }

    /***** Render *****/

    return (
        <ClickAwayListener onClickAway={onTooltipClose}>
            <IconButton onClick={onInfoButtonClicked} {...props.IconButtonProps}>
                <Tooltip
                    arrow
                    open={open}
                    onOpen={onTooltipOpen}
                    onClose={onTooltipClose}
                    // leaveTouchDelay={15000}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    interactive
                    title={
                        <Typography style={{ textAlign: 'center' }}>
                            {props.title}
                        </Typography>
                    }>
                    {props.icon
                        ? props.icon
                        : <InformationOutline color="primary" />
                    }
                </Tooltip>
            </IconButton>
        </ClickAwayListener>
    );
});

export default InformationTooltip;